module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: {
      'thumbnail-mobile': _vm.isMobile === true, 'col-xs-12 col-sm-4 col-md-3': _vm.isMobile === false
    },
    attrs: {
      "href": _vm.newURL(),
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.baseImage + _vm.thumbnail.businessId + '.png), url(' + _vm.baseImage + _vm.thumbnail.businessId + '.jpeg), url(' + _vm.fallbackImage + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('h3', {
    staticClass: "truncate"
  }, [_vm._v(_vm._s(_vm._f("truncate")(_vm.thumbnail.nomAplicacio, 40)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("truncate")(_vm.thumbnail.description, 70)))]), _vm._v(" "), _c('span', {
    staticClass: "nom-usuari"
  }, [_vm._v(_vm._s(_vm._f("truncate")(_vm.thumbnail.usuari, 40)))])]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("favorite_border")]), _c('span', [_vm._v(_vm._s(_vm.thumbnail.rank))]), _c('span', [_vm._v(_vm._s(_vm._f("dateDay")(_vm.thumbnail.dataPublicacio)) + "-" + _vm._s(_vm._f("dateMonth")(_vm.thumbnail.dataPublicacio, _vm.selectedLang)) + "-" + _vm._s(_vm._f("dateYear")(_vm.thumbnail.dataPublicacio)))]), _vm._v(" "), (_vm.isClonable(_vm.thumbnail)) ? _c('span', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "title": _vm.getTitle()
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.clonarMapa($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("content_copy")])])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-437542da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/thumbnailmap/thumbnailmap.vue
// module id = 301
// module chunks = 0